export class DeviationCalculator {
  public static calculateDeviation(array: Array<number>): number {
    let mean: number = DeviationCalculator.calculateMean(array);
    let totalDistanceSum = DeviationCalculator.calculateTotalDistanceSum(mean, array);
    let averageDistance = totalDistanceSum / array.length;

    return Math.sqrt(averageDistance);
  }

  private static calculateMean(array: Array<number>): number {
    let sum: number = 0;

    array.forEach(value => { sum += value });
    return sum / array.length;
  }

  private static findDistance(value: number, mean: number): number {
    return mean - value;
  }

  private static calculateTotalDistanceSum(mean: number, array: Array<number>) {
    let squareSum: number = 0;
    array.forEach((value: number) => {
      squareSum += Math.pow(DeviationCalculator.findDistance(value, mean), 2);
    });

    return squareSum;
  }
}
